export const TMDB_URL =
  process.env.REACT_APP_TMDB_URL || "https://api.themoviedb.org/3/";
export const TMDB_IMAGE_URL =
  process.env.REACT_APP_TMDB_IMAGE_URL || "https://image.tmdb.org/t/p/";
export const TMDB_API_KEY = process.env.REACT_APP_TMDB_API_KEY || "";
export const EMBED_URL = "https://vidsrc.to/embed";
// process.env.REACT_APP_EMBED_URL || "https://vidsrc.cc/v2/embed";
